import { useEffect, useMemo, useState } from 'react';

function hashString(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

/**
 * Cycles 0..count-1 on an interval while `active`, for rotating "working…" labels.
 * `seedKey` (e.g. the notification id) desyncs concurrent rows: it offsets the starting index and
 * jitters the interval so several rows don't rotate in lockstep. Returns 0 when inactive.
 */
export function useRotatingIndex(count: number, active: boolean, seedKey = ''): number {
  const seed = useMemo(() => hashString(seedKey), [seedKey]);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!active || count <= 1) return;
    const intervalMs = 2000 + (seed % 1200); // 2.0–3.2s, varies per item → no lockstep
    const id = setInterval(() => setTick(current => current + 1), intervalMs);
    return () => clearInterval(id);
  }, [active, count, seed]);

  return active ? (tick + seed) % count : 0;
}
